import React, { useEffect } from "react";

const TopicsBtn = (props) => {
  return (
    <a style={{ textDecoration: "none", color: "black" }} href={`/category/${props.topic}`}>
      <div className="small_topic_btn">
        <p className="mb_0">{props.topic}</p>
      </div>
    </a>
  );
};

const SmallTopicList = () => {
  return (
    <div className="mauto mb_4rem mt_4rem">
      <p className="tgrey fs20px">
        <i class="fas fa-search"></i> Other topics
      </p>
      <div className="d-flex topic_scroll_x">
        <TopicsBtn topic="GST" />
        <TopicsBtn topic="TAX" />
        <TopicsBtn topic="FINANCE" />
        <TopicsBtn topic="ACCOUNTS" />
        <TopicsBtn topic="STARTUP" />
      </div>
      {/* <i class="fas fa-arrow-right fr"></i> */}
    </div>
  );
};
export default SmallTopicList;
